"use client";

import { clsx } from "@trydig/ui";
import { Cart as CartIcon } from "~/components/icons/24/Cart";
import type { CartTriggerProps } from "~/features/cart";
import { useCart } from "~/lib/hooks/useCart";

export const CartTrigger = ({ onClick, styles, activeStyles }: CartTriggerProps) => {
	const { itemCount } = useCart();
	const isCartActive = itemCount > 0;

	return (
		<button className={clsx(styles, isCartActive && activeStyles)} onClick={onClick}>
			<CartIcon />
		</button>
	);
};
